import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ToolsIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    {...props}
    sx={{ fill: 'none' }}
  >
    <path
      d="M10.5899 15.21C11.1599 15.79 12.9799 17.62 13.5899 18.28C10.6599 21.37 7.91989 24.28 7.50989 24.68C7.29465 24.8762 7.04076 25.0253 6.76451 25.1177C6.48825 25.2101 6.19574 25.2437 5.90573 25.2164C5.61572 25.1891 5.33462 25.1015 5.08046 24.9592C4.82631 24.8168 4.60471 24.623 4.42989 24.39C3.10989 23 3.56989 21.92 3.99989 21.44C4.42989 20.96 7.49989 18.15 10.5899 15.21Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M23.1497 10.1097C22.713 10.0833 22.2766 10.1657 21.8797 10.3497C20.6161 11.2831 19.4043 12.2846 18.2497 13.3497C17.7297 13.9097 17.7897 13.9097 16.4297 15.3497L13.4297 12.3497C14.8897 10.9797 14.8897 11.0397 15.4297 10.5097C16.5977 9.45184 17.703 8.32659 18.7397 7.13972C18.908 6.78306 18.9967 6.39408 18.9997 5.99972C18.9997 4.99972 20.2397 2.23972 23.6697 2.92972L21.4697 5.12972C21.4032 5.1949 21.3503 5.27269 21.3142 5.35855C21.2782 5.4444 21.2596 5.53659 21.2596 5.62972C21.2596 5.72285 21.2782 5.81504 21.3142 5.9009C21.3503 5.98675 21.4032 6.06455 21.4697 6.12972L22.9997 7.63972C23.0641 7.7075 23.1417 7.76146 23.2277 7.79833C23.3136 7.83521 23.4062 7.85422 23.4997 7.85422C23.5932 7.85422 23.6858 7.83521 23.7717 7.79833C23.8577 7.76146 23.9352 7.7075 23.9997 7.63972L26.1997 5.43972C26.9197 8.86972 24.1897 10.1397 23.1497 10.1097Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M8.51953 13.0998L11.3195 10.2998"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M6.40078 23.2996C6.87022 23.2996 7.25078 22.9191 7.25078 22.4496C7.25078 21.9802 6.87022 21.5996 6.40078 21.5996C5.93134 21.5996 5.55078 21.9802 5.55078 22.4496C5.55078 22.9191 5.93134 23.2996 6.40078 23.2996Z"
      fill="white"
    />
    <path
      d="M20.1095 24.82C19.7095 24.4 10.5895 15.21 10.5895 15.21L7.9995 12.56C7.9995 12.56 6.4595 11.14 5.6695 11.93C5.0995 12.5 5.1695 12.93 5.2595 13.1C5.28101 13.1327 5.29247 13.1709 5.29247 13.21C5.29247 13.2491 5.28101 13.2874 5.2595 13.32L4.3495 14.27L4.2295 14.34C3.91801 14.4052 3.59447 14.3817 3.2957 14.2721C2.99693 14.1625 2.73493 13.9712 2.5395 13.72C1.5895 12.72 1.6395 12.28 1.8595 12.05C2.0795 11.82 2.9995 10.9 3.2995 10.62C3.32193 10.6058 3.34794 10.5983 3.3745 10.5983C3.40106 10.5983 3.42707 10.6058 3.4495 10.62C3.6595 10.7 4.2195 10.89 4.4495 10.62C4.6795 10.35 4.4495 9.12004 4.5695 8.89004C4.6895 8.66004 9.2095 4.27004 12.2195 2.79004L12.6995 3.28004C12.6995 3.28004 8.4095 6.77004 10.6995 9.86004L13.3695 12.46L23.0695 21.82C23.3731 22.222 23.5065 22.7272 23.441 23.2267C23.3756 23.7262 23.1164 24.1799 22.7195 24.49C22.4111 24.8712 21.9673 25.1183 21.4809 25.1798C20.9944 25.2413 20.5031 25.1124 20.1095 24.82Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
);
